/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */
setTimeout(function() {
  $('#store-locator-title').prepend('<div class="store-locator-subtitle">where to find us</div>');
}, 700);

$('.jdgm-prev-badge').click(function() {
  $('html, body').animate({
    scrollTop: $('.review').offset().top - 250
  }, 1500);
  $('.review').trigger('click');
});

$(".custom_option option").each(function() {
  if ($(this).text() == $('.ProductForm__SelectedValue').text()) {
    $(this).attr('selected', '');
    //$(this).addClass('selected');
  } else {
    //console.log('no');
  }
});

/**
 * Handle Variant Change
 *
 * Customised by: chris@breaksagency.com
 *
 * - use parent $formElement to prevent slippage of function
 *   to other .ProductForm elements on the page.
 */
$('.custom_option').change(function() {
  $formElement = $(this).parents('.ProductForm');
  $formElement.find('.ProductForm__AddToCart').removeClass("disabled").removeAttr('disabled');;
  $(this).find(':selected').addClass('selected').siblings('option').removeClass('selected');
  $formElement.find('.product_form_select').siblings('option').removeAttr('selected');
  var sel_val = $(this).val();
  $('.Popover__Value ').removeClass('is-main-click');
  var txt = $formElement.find('.custom_option').find('.selected').text();
  if (txt == "Choose your size") {
    $formElement.find('.ProductForm__AddToCart').addClass("disabled");
    $formElement.find('.ProductForm__AddToCart').attr("disabled", "disabled");
    $formElement.find('.product_form_select option[value=""]').prop("selected", true);
    $formElement.find('.custom_option option[value=""]').prop("selected", true);
    $(".ProductForm__Inventory").html("");
  } else {
    $formElement.find('.ProductForm__Error').remove();
    $formElement.find('.custom_option option[value="' + sel_val + '"]').prop("selected", true);
    $formElement.find(".product_form_select")[0].selectedIndex = $(this)[0].selectedIndex;
    $formElement.find(".product_form_select option:eq(" + $(this)[0].selectedIndex + ")").prop("selected", true);
  }

  $(".Popover__Value").each(function() {
    if ($('.custom_option').find('.selected').text() == $(this).text()) {
      $(this).addClass('is-selected');
      $(this).addClass('is-main-click');
      $(".is-main-click").click();
      $formElement.find('.ProductForm__SelectedValue').text($(this).text());
    }
  });
});

/* Set disabled class on load */
$(document).ready(function() {
  $('[data-action="add-to-cart"]').attr('disabled', 'disabled')
})

$(document).ready(function() {
  $(window).on("load", function() {
    var variants_length = $('.variant_length').val();
    var options_length = $('.variant_length').attr("data-options");
    var option_value = $('.option_value').val();
    if (options_length >= 1 && variants_length > 1) {
      $(".ProductForm__Inventory").html("");
      $('.custom_option option').removeAttr("selected");
      $('.ProductForm__AddToCart').addClass("disabled");
      if (option_value == "true") {} else {
        $('.product_form_select option[value=""]').prop("selected", true);
        $('.custom_option option[value=""]').prop("selected", true);
      }
    }
  });
});


/**
 * Handle 'Out of Stock' text on product-items
 * Author: chris@breaksagency.com
 */
$(document).ready(function() {
  var initStockLevelMessaging = function() {

    // Stock level (beneath which) the the warning will display
    var stockThreshold = 3

    // Set some variables we'll need along the way
    var $productForms = $('.js-form-custom-js');
    var $stockLevelText = $('.js-stock-level');
    var $stockMessage = $('.js-stock-message');

    /* Returns the selected variant ID from a given <form> */
    var getSelectedVariantID = function($form) {
      return $form.serializeArray().find(function(item) {
        return item.name == 'id'
      }).value
    }

    /* Updates the Stock Level message in the UI */
    var updateStockMessage = function($form, currentStockLevel) {

      // Find the container for the stock level text
      $form.find($stockLevelText).text(currentStockLevel)

      // If there is less stock than our threshold, show the message
      if (currentStockLevel <= stockThreshold) {
        $form.find($stockMessage).removeClass('js-hidden')
      } else {
        $form.find($stockMessage).addClass('js-hidden')
      }
    }

    /* Does the bulk of the work, and fires the above functions. */
    var handleOptionChange = function($form, inventories) {

      // Get updated variant ID
      var selectedVariantID = getSelectedVariantID($form)

      // Match it to the inventories object to find the stock level
      var stockLevel = inventories[selectedVariantID].inventory_quantity

      // Update the stock message
      updateStockMessage($form, stockLevel)
    }

    /* Loop through each product <form>, because there may be more than one */
    $productForms.each(function() {
      var allData = JSON.parse($(this).siblings('[data-product-json]')[0].innerHTML);
      var inventories = allData.inventories
      var $form = $(this);

      $(this).find('.custom_option').on('change', function(){
        handleOptionChange($form, inventories)
      })
    });
  }

  initStockLevelMessaging()
});

/**
 * Prim connector
 * Author: james@breaksagency.com
 */

// check if window.productStock exist, basic check that the browser isn't a crawler
// post window.productStock to the AWS endpoint
if (window.productStock && !/bot|google|baidu|bing|msn|duckduckbot|teoma|slurp|yandex/i.test(navigator.userAgent)) {
  fetch('https://ew8g62l046.execute-api.eu-west-1.amazonaws.com/prod/fwm', {
    method: 'post',
    headers: new Headers({
      'Content-Type': 'application/json'
    }),
    body: JSON.stringify(window.productStock)
  })
}

$.fn.isInViewport = function () {
  var elementTop = $(this).offset().top;
  var elementBottom = elementTop + $(this).outerHeight();
  var viewportTop = $(window).scrollTop();
  var viewportBottom = viewportTop + $(window).height();
  return elementBottom > viewportTop && elementTop < viewportBottom;
}
